import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BaseSmartComponent } from './../base.component';
import { MessageService } from '@/services/message.service';
import { UI_MASKS } from '@/utils/uiMasks';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
    selector: 'shared-modal',
   templateUrl: './modal.template.html',
   host: {'class': 'shared-modal-component'},
   animations: [
    trigger('generate', [
      state('none', style({
        transform: 'scale(0)',
        opacity: 0
      })),
      state('block', style({
        transform: 'scale(1)',
        opacity: 1
      })),
      transition('block=>none', animate('100ms')),
      transition('none=>block', animate('250ms'))
    ]),
    trigger('fadeIn', [
      state('none', style({
        opacity: 0
      })),
      state('block', style({
        opacity: 1
      })),
      transition('block=>none', animate('100ms')),
      transition('none=>block', animate('250ms'))
    ]),
   ]
})

export class ModalComponent extends BaseSmartComponent {
    @ViewChild('childModal', {static: true})
    childModal: ModalDirective;

    @Input()
    model: any;

    @Input() title: string;

    @Input()
    display: string = 'none';

    @Input()
    type: string;

    @Input()
    showAlert: boolean = false;

    @Output()
    onClose: EventEmitter<string> = new EventEmitter<string>();

    @Output()
    onSave: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    onNavigate: EventEmitter<any> = new EventEmitter<any>();

    public isNew: boolean = true;

    constructor(messageService: MessageService, private uiMasks: UI_MASKS) {
      super(messageService);
    }
  show(): void {
    this.childModal.show();
  }

  hide(): void {
    this.childModal.hide();
  }

  onCloseHandled(): void {
    this.display = 'none';
    this.onClose.emit(this.display);
  }

  saveModel(model: any): void {
    this.onSave.emit(model);
  }

  goToContact(): void {
    this.onNavigate.emit(null);
  }
}
